export const findOneSetting = (settings, key) => {
  return settings.find(item => item.settings.name === key)
};

export const findSettings = (settings, key) => {
  return settings.filter(item => item.settings.name === key)
}